<template>
  <div v-loading="loading" class="talent-matrix-setting">
    <div v-if="matrix && matrix.setting">

      <el-form
        label-position="right"
        label-width="180px"
      >
        <el-form-item class="talent-matrix-setting-item">
          <div slot="label">
            Оси
            <el-popover
              placement="top"
              width="400"
              trigger="click"
            >
              <el-button
                slot="reference"
                class="table-action-button open-desc-button"
                type="text"
                round
                size="mini"
                icon="fas fa-info-circle"
              ></el-button>
              <div style="white-space: pre-line">Выберите, какая оценка относятся к потенциалу, а какая к производительности.<br>
                Для построения матрицы будут использоваться последние полученные оценки сотрудников.<br>
                Также вы можете импортировать свои данные файлом в формате excel по шаблону.
              </div>
            </el-popover>
          </div>

          <div class="setting-axis">
            <div class="axis">
              <div style="display: flex;justify-content: space-between;">
                <div style="font-weight: bold">Потенциал (ось Y)</div>
                <div>
                  <el-radio-group
                    v-model="matrix.setting.potential_is_import"
                    size="mini"
                    @change="updateSetting"
                  >
                    <el-radio-button :label="true"><i class="fas fa-file-excel"></i> Из файла</el-radio-button>
                    <el-radio-button :label="false">Из оценки</el-radio-button>
                  </el-radio-group>
                </div>
              </div>

              <div style="margin-top: 10px">
                <div v-if="!matrix.setting.potential_is_import">
                  <el-form
                    label-position="right"
                    label-width="80px"
                    size="small"
                  >
                    <el-form-item label="Оценка">
                      <eval-evaluations-select
                        v-model="matrix.setting.potential_evaluation_id"
                        :multiple="false"
                        @change="updateSetting"
                      ></eval-evaluations-select>
                    </el-form-item>
                    <el-form-item label="Формула">
                      <talent-matrix-axis-formula-select
                        v-model="matrix.setting.potential_formula"
                        :multiple="false"
                        @change="updateSetting"
                      ></talent-matrix-axis-formula-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-else>
                  <div style="display: flex;justify-content: space-between">
                    <el-button
                      icon="fas fa-list-alt"
                      @click="openAxisUserValuesDialog('potential')"
                    >
                      Список загруженных оценок ({{ matrix.import_potential_count }})
                    </el-button>

                    <import-modal
                      entity="matrix_productivity_potential"
                      title="Импорт потенциала"
                      close-on-success
                      :data="{'matrix_id': $route.params.id, 'type': 'potential'}"
                      @import-succeed="importSucceed"
                    >
                      <template v-slot:reference>
                        <el-button icon="fas fa-file-import" >
                          Загрузить из XLSX
                        </el-button>
                      </template>
                    </import-modal>

                  </div>
                </div>
              </div>
            </div>
            <div class="axis">
              <div style="display: flex;justify-content: space-between;">
                <div style="font-weight: bold">Производительность (ось X)</div>
                <div>
                  <el-radio-group
                    v-model="matrix.setting.productivity_is_import"
                    size="mini"
                    @change="updateSetting"
                  >
                    <el-radio-button :label="true"><i class="fas fa-file-excel"></i> Из файла</el-radio-button>
                    <el-radio-button :label="false">Из оценки</el-radio-button>
                  </el-radio-group>
                </div>
              </div>

              <div style="margin-top: 10px">
                <div v-if="!matrix.setting.productivity_is_import">
                  <el-form
                    label-position="right"
                    label-width="80px"
                    size="small"
                  >
                    <el-form-item label="Оценка">
                      <eval-evaluations-select
                        v-model="matrix.setting.productivity_evaluation_id"
                        :multiple="false"
                        @change="updateSetting"
                      ></eval-evaluations-select>
                    </el-form-item>
                    <el-form-item label="Формула">
                      <talent-matrix-axis-formula-select
                        v-model="matrix.setting.productivity_formula"
                        :multiple="false"
                        @change="updateSetting"
                      ></talent-matrix-axis-formula-select>
                    </el-form-item>
                  </el-form>
                </div>
                <div v-else>
                  <div style="display: flex;justify-content: space-between">
                    <div>
                      <el-button
                        icon="fas fa-list-alt"
                        @click="openAxisUserValuesDialog('productivity')"
                      >
                        Список загруженных оценок ({{ matrix.import_productivity_count }})
                      </el-button>
                    </div>

                    <import-modal
                      entity="matrix_productivity_potential"
                      title="Импорт производительности"
                      close-on-success
                      :data="{'matrix_id': $route.params.id, 'type': 'productivity'}"
                      @import-succeed="importSucceed"
                    >
                      <template v-slot:reference>
                        <el-button icon="fas fa-file-import" >
                          Загрузить из XLSX
                        </el-button>
                      </template>
                    </import-modal>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item class="talent-matrix-setting-item">
          <div slot="label">
            Размер матрицы
            <el-popover
              placement="top"
              width="400"
              trigger="click"
            >
              <el-button
                slot="reference"
                class="table-action-button open-desc-button"
                type="text"
                round
                size="mini"
                icon="fas fa-info-circle"
              ></el-button>
              <div style="white-space: pre-line">Выберите, какой размер будет у потенциала, а какой у производительности.<br>
                Минимальное значение - 1, максимальное значение - 5.
              </div>
            </el-popover>
          </div>

          <div class="setting-size">
            <div class="size">
              <div>Потенциал (ось Y)</div>
              <div style="margin-top: 10px">
                <el-input
                  placeholder="Ось Y"
                  v-model.number="matrix.setting.potential_size"
                  style="width: 100px"
                  :min="1"
                  :max="5"
                  type="number"
                  @input="value => onInputSize('potential_size', value)"
                  @change="updateSetting(true)"
                />
              </div>
            </div>
            <div class="size">
              <div>Производительность (ось X)</div>
              <div style="margin-top: 10px">
                <el-input
                  placeholder="Ось X"
                  v-model.number="matrix.setting.productivity_size"
                  style="width: 100px"
                  :min="1"
                  :max="5"
                  type="number"
                  @input="value => onInputSize('productivity_size', value)"
                  @change="updateSetting(true)"
                />
              </div>
            </div>
          </div>
        </el-form-item>

        <el-form-item class="talent-matrix-setting-item">
          <div slot="label">
            Матрица
            <el-popover
              placement="top"
              width="400"
              trigger="click"
            >
              <el-button
                slot="reference"
                class="table-action-button open-desc-button"
                type="text"
                round
                size="mini"
                icon="fas fa-info-circle"
              ></el-button>
              <div style="white-space: pre-line">Вы можете менять местами ячейки просто перетаскивая их.</div>
            </el-popover>
          </div>

          <preview-talent-matrix
            @update-matrix="updateMatrix()"
            :matrix="matrix"
          ></preview-talent-matrix>
        </el-form-item>

        <el-form-item class="talent-matrix-setting-item">
          <div slot="label">
            Видимость
            <el-popover
              placement="top"
              width="400"
              trigger="click"
            >
              <el-button
                slot="reference"
                class="table-action-button open-desc-button"
                type="text"
                round
                size="mini"
                icon="fas fa-info-circle"
              ></el-button>
              <div style="white-space: pre-line">Выберите, будут ли пользователи видеть всех сотрудников в матрице или только тех, кто доступен им по настройкам ролевой модели.</div>
            </el-popover>
          </div>

          <el-radio-group
            v-model="matrix.setting.visibility_all_users"
          >
            <el-radio
              :key="true"
              :label="true"
              border
              @change="updateSetting"
            >
              Все пользователи
            </el-radio>
            <el-radio
              :key="false"
              :label="false"
              border
              @change="updateSetting"
            >
              Пользователи, доступные по ролевой модели
            </el-radio>
          </el-radio-group>
        </el-form-item>

        <el-form-item class="talent-matrix-setting-item">
          <div slot="label">
            Доступ
            <el-popover
              placement="top"
              width="400"
              trigger="click"
            >
              <el-button
                slot="reference"
                class="table-action-button open-desc-button"
                type="text"
                round
                size="mini"
                icon="fas fa-info-circle"
              ></el-button>
              <div style="white-space: pre-line">Выберите пользователей, которые смогут открыть матрицу по ссылке в режиме просмотра.</div>
            </el-popover>
          </div>

          <share-talent-matrix-users-table
            style="width: 1200px; margin-left: 20px"
          ></share-talent-matrix-users-table>
        </el-form-item>





      </el-form>
    </div>


    <talent-matrix-axis-user-values-dialog
      @update-matrix="updateMatrix()"
      ref="showAxisUserValuesDialog"
    >
    </talent-matrix-axis-user-values-dialog>
  </div>
</template>

<script>
import EvalEvaluationsSelect from "@/modules/evaluation/components/EvalEvaluationsSelect.vue";
import PreviewTalentMatrix from "@/modules/talentMatrix/components/PreviewTalentMatrix.vue";
import TalentMatrixAxisFormulaSelect from "@/modules/talentMatrix/components/TalentMatrixAxisFormulaSelect.vue";
import TalentMatrixAxisUserValuesDialog from "@/modules/talentMatrix/components/TalentMatrixAxisUserValuesDialog.vue";
import ShareTalentMatrixUsersTable from "@/modules/talentMatrix/components/ShareTalentMatrixUsersTable.vue";
import ImportModal from "@/components/exportImport/ImportModal.vue";
import CascadingElementHiddenProp from "@/modules/cascading/components/CascadingElementHiddenProp.vue";

export default {
  name: 'talent-matrix-setting',
  components: {
    CascadingElementHiddenProp,
    ImportModal,
    EvalEvaluationsSelect,
    TalentMatrixAxisFormulaSelect,
    TalentMatrixAxisUserValuesDialog,
    PreviewTalentMatrix,
    ShareTalentMatrixUsersTable,
  },
  props: {
    loading: false,
    matrix: {
      type: Object,
      default: {},
    },
  },
  methods: {
    openAxisUserValuesDialog(type) {
      this.$refs.showAxisUserValuesDialog.open(type);
    },
    updateSetting(updateMatrixData = false) {
      this.$api.talentMatrix.matrixSettingUpdate({
        ...this.matrix.setting
      })
      .finally(() => {
        if (updateMatrixData) {
          this.$emit('update-matrix-data');
        }
      });
    },
    onInputSize(field, value) {
      let digits = parseInt(String(value).replace(/\D/g, ''), 10);
      if (!isNaN(digits)) {
        this.matrix.setting[field] = Math.min(Math.max(digits, 1), 5);
      } else {
        this.matrix.setting[field] = null;
      }
    },
    updateMatrix() {
      this.$emit('update-matrix');
    },
    importSucceed() {
      this.updateMatrix();
      this.$notify.success({
        title: 'Завершено',
        message: 'Импорт завершен успешно'
      });
    },
  },
}
</script>

<style scoped>
  .talent-matrix-setting {
    .setting-size,
    .setting-axis {
      display: flex;
      gap: 80px;
      justify-content: flex-start;
    }

    .axis {
      width: 500px;
    }

    .el-form-item.talent-matrix-setting-item {
      margin-bottom: 50px;
    }
  }
</style>